// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { EditPersonalizationOptionPage_Slot_TakeoffLineItemFragmentDoc } from '../EditPersonalizationOptionPage.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AddSlotModal_PotentialPlaceholdersQueryVariables = Types.Exact<{
  designPackageId: Types.Scalars['ID']['input'];
  versionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type AddSlotModal_PotentialPlaceholdersQuery = { __typename?: 'Query', takeoffLineItemsPage: { __typename?: 'TakeoffLineItemsPage', items: Array<{ __typename?: 'TakeoffLineItem', id: string, name: string, personalizationShadowPlaceholder?: { __typename?: 'TakeoffLineItem', id: string } | null | undefined, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, location: { __typename?: 'Location', id: string, displayLocationPath: string } }> } };

export type AddSlotModal_SelectedPlaceholdersQueryVariables = Types.Exact<{
  designPackageId: Types.Scalars['ID']['input'];
  tliIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type AddSlotModal_SelectedPlaceholdersQuery = { __typename?: 'Query', takeoffLineItemsPage: { __typename?: 'TakeoffLineItemsPage', items: Array<{ __typename?: 'TakeoffLineItem', id: string, name: string, location: { __typename?: 'Location', id: string, displayLocationPath: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, products: Array<{ __typename?: 'TakeoffLineItem', id: string, active: boolean, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> }> }> } };


export const AddSlotModal_PotentialPlaceholdersDocument = gql`
    query AddSlotModal_PotentialPlaceholders($designPackageId: ID!, $versionId: ID) {
  takeoffLineItemsPage(
    filter: {readyPlan: [$designPackageId], designPackageType: [REGULAR_PLACEHOLDER]}
    versionId: $versionId
    first: 1000
  ) {
    items {
      id
      name
      personalizationShadowPlaceholder {
        id
      }
      materialVariant {
        id
      }
      location {
        id
        displayLocationPath
      }
    }
  }
}
    `;

/**
 * __useAddSlotModal_PotentialPlaceholdersQuery__
 *
 * To run a query within a React component, call `useAddSlotModal_PotentialPlaceholdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddSlotModal_PotentialPlaceholdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddSlotModal_PotentialPlaceholdersQuery({
 *   variables: {
 *      designPackageId: // value for 'designPackageId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useAddSlotModal_PotentialPlaceholdersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddSlotModal_PotentialPlaceholdersQuery, AddSlotModal_PotentialPlaceholdersQueryVariables> & ({ variables: AddSlotModal_PotentialPlaceholdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddSlotModal_PotentialPlaceholdersQuery, AddSlotModal_PotentialPlaceholdersQueryVariables>(AddSlotModal_PotentialPlaceholdersDocument, options);
      }
export function useAddSlotModal_PotentialPlaceholdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddSlotModal_PotentialPlaceholdersQuery, AddSlotModal_PotentialPlaceholdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddSlotModal_PotentialPlaceholdersQuery, AddSlotModal_PotentialPlaceholdersQueryVariables>(AddSlotModal_PotentialPlaceholdersDocument, options);
        }
export function useAddSlotModal_PotentialPlaceholdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddSlotModal_PotentialPlaceholdersQuery, AddSlotModal_PotentialPlaceholdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddSlotModal_PotentialPlaceholdersQuery, AddSlotModal_PotentialPlaceholdersQueryVariables>(AddSlotModal_PotentialPlaceholdersDocument, options);
        }
export type AddSlotModal_PotentialPlaceholdersQueryHookResult = ReturnType<typeof useAddSlotModal_PotentialPlaceholdersQuery>;
export type AddSlotModal_PotentialPlaceholdersLazyQueryHookResult = ReturnType<typeof useAddSlotModal_PotentialPlaceholdersLazyQuery>;
export type AddSlotModal_PotentialPlaceholdersSuspenseQueryHookResult = ReturnType<typeof useAddSlotModal_PotentialPlaceholdersSuspenseQuery>;
export type AddSlotModal_PotentialPlaceholdersQueryResult = Apollo.QueryResult<AddSlotModal_PotentialPlaceholdersQuery, AddSlotModal_PotentialPlaceholdersQueryVariables>;
export const AddSlotModal_SelectedPlaceholdersDocument = gql`
    query AddSlotModal_SelectedPlaceholders($designPackageId: ID!, $tliIds: [ID!]!) {
  takeoffLineItemsPage(filter: {readyPlan: [$designPackageId], id: $tliIds}) {
    items {
      ...EditPersonalizationOptionPage_Slot_TakeoffLineItem
    }
  }
}
    ${EditPersonalizationOptionPage_Slot_TakeoffLineItemFragmentDoc}`;

/**
 * __useAddSlotModal_SelectedPlaceholdersQuery__
 *
 * To run a query within a React component, call `useAddSlotModal_SelectedPlaceholdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddSlotModal_SelectedPlaceholdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddSlotModal_SelectedPlaceholdersQuery({
 *   variables: {
 *      designPackageId: // value for 'designPackageId'
 *      tliIds: // value for 'tliIds'
 *   },
 * });
 */
export function useAddSlotModal_SelectedPlaceholdersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddSlotModal_SelectedPlaceholdersQuery, AddSlotModal_SelectedPlaceholdersQueryVariables> & ({ variables: AddSlotModal_SelectedPlaceholdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddSlotModal_SelectedPlaceholdersQuery, AddSlotModal_SelectedPlaceholdersQueryVariables>(AddSlotModal_SelectedPlaceholdersDocument, options);
      }
export function useAddSlotModal_SelectedPlaceholdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddSlotModal_SelectedPlaceholdersQuery, AddSlotModal_SelectedPlaceholdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddSlotModal_SelectedPlaceholdersQuery, AddSlotModal_SelectedPlaceholdersQueryVariables>(AddSlotModal_SelectedPlaceholdersDocument, options);
        }
export function useAddSlotModal_SelectedPlaceholdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddSlotModal_SelectedPlaceholdersQuery, AddSlotModal_SelectedPlaceholdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddSlotModal_SelectedPlaceholdersQuery, AddSlotModal_SelectedPlaceholdersQueryVariables>(AddSlotModal_SelectedPlaceholdersDocument, options);
        }
export type AddSlotModal_SelectedPlaceholdersQueryHookResult = ReturnType<typeof useAddSlotModal_SelectedPlaceholdersQuery>;
export type AddSlotModal_SelectedPlaceholdersLazyQueryHookResult = ReturnType<typeof useAddSlotModal_SelectedPlaceholdersLazyQuery>;
export type AddSlotModal_SelectedPlaceholdersSuspenseQueryHookResult = ReturnType<typeof useAddSlotModal_SelectedPlaceholdersSuspenseQuery>;
export type AddSlotModal_SelectedPlaceholdersQueryResult = Apollo.QueryResult<AddSlotModal_SelectedPlaceholdersQuery, AddSlotModal_SelectedPlaceholdersQueryVariables>;